import type { IconProps } from './IconProps';

export const ArrowsSwitchIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 17}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1362 1.96967C10.4291 1.67678 10.9039 1.67678 11.1968 1.96967L13.8635 4.63634C14.1564 4.92923 14.1564 5.4041 13.8635 5.697L11.1968 8.36366C10.9039 8.65656 10.4291 8.65656 10.1362 8.36366C9.84328 8.07077 9.84328 7.5959 10.1362 7.303L11.5225 5.91667H2.6665C2.25229 5.91667 1.9165 5.58088 1.9165 5.16667C1.9165 4.75245 2.25229 4.41667 2.6665 4.41667H11.5225L10.1362 3.03033C9.84328 2.73744 9.84328 2.26256 10.1362 1.96967ZM5.8635 8.63634C6.15639 8.92923 6.15639 9.4041 5.8635 9.697L4.47716 11.0833H13.3332C13.7474 11.0833 14.0832 11.4191 14.0832 11.8333C14.0832 12.2475 13.7474 12.5833 13.3332 12.5833H4.47716L5.8635 13.9697C6.15639 14.2626 6.15639 14.7374 5.8635 15.0303C5.57061 15.3232 5.09573 15.3232 4.80284 15.0303L2.13617 12.3637C1.84328 12.0708 1.84328 11.5959 2.13617 11.303L4.80284 8.63634C5.09573 8.34344 5.57061 8.34344 5.8635 8.63634Z"
      fill="currentColor"
    />
  </svg>
);
